import {COMMUNITY_DEFAULT_LOGO_URL, COMMUNITY_NAME_MAX_LENGTH } from "../config/Common";

export function getCommunityDisplayName (community) {
  return (
    community.abbreviation ||
    (community.name.length <= COMMUNITY_NAME_MAX_LENGTH
      ? community.name
      : community.name.substring(0, COMMUNITY_NAME_MAX_LENGTH) + " ...")
  );
}

export function getCommunityLogoUrl(community) {
  return community && community.avatarUrl
    ? community.avatarUrl
    : COMMUNITY_DEFAULT_LOGO_URL;
}



// WEBPACK FOOTER //
// ./app/services/auth.js